export const GET_EDM_DATASETS = '[ADMIN_EDM] Get datasets';
export const GET_EDM_DATASETS_SUCCESS = '[ADMIN_EDM] Get datasets success';
export const GET_EDM_DATASETS_FAILED = '[ADMIN_EDM] Get datasets failed';

export const CREATE_EDM_DATASET = '[ADMIN_EDM] Create dataset';
export const CREATE_EDM_DATASET_SUCCESS = '[ADMIN_EDM] Create dataset success';
export const CREATE_EDM_DATASET_FAILED = '[ADMIN_EDM] Create dataset failed';

export const GET_EDM_DATASET = '[ADMIN_EDM] Get dataset';
export const GET_EDM_DATASET_SUCCESS = '[ADMIN_EDM] Get dataset success';
export const GET_EDM_DATASET_FAILED = '[ADMIN_EDM] Get dataset failed';

export const UPDATE_EDM_DATASET = '[ADMIN_EDM] Update dataset';
export const UPDATE_EDM_DATASET_SUCCESS = '[ADMIN_EDM] Update dataset success';
export const UPDATE_EDM_DATASET_FAILED = '[ADMIN_EDM] Update dataset failed';

export const RECOMPUTE_EDM_DATASET = '[ADMIN_EDM] Recompute dataset';
export const RECOMPUTE_EDM_DATASET_SUCCESS = '[ADMIN_EDM] Recompute dataset success';
export const RECOMPUTE_EDM_DATASET_FAILED = '[ADMIN_EDM] Recompute dataset failed';

export const GET_EDM_DATASET_SUMMARY = '[ADMIN_EDM] Get dataset summary';
export const GET_EDM_DATASET_SUMMARY_SUCCESS = '[ADMIN_EDM] Get dataset summary success';
export const GET_EDM_DATASET_SUMMARY_FAILED = '[ADMIN_EDM] Get dataset summary failed';

export const GET_EDM_DATASET_BLOCKED = '[ADMIN_EDM] Get dataset blocked';
export const GET_EDM_DATASET_BLOCKED_SUCCESS = '[ADMIN_EDM] Get dataset blocked success';
export const GET_EDM_DATASET_BLOCKED_FAILED = '[ADMIN_EDM] Get dataset blocked failed';

export const VALIDATE_EDM_DATASET_MEDIA = '[ADMIN_EDM] Validate dataset media';
export const VALIDATE_EDM_DATASET_MEDIA_SUCCESS = '[ADMIN_EDM] Validate dataset media success';
export const VALIDATE_EDM_DATASET_MEDIA_FAILED = '[ADMIN_EDM] Validate dataset media failed';

export const GET_EDM_DATASET_HANDOFF_PACKAGE = '[ADMIN_EDM] Get dataset handoff package';
export const GET_EDM_DATASET_HANDOFF_PACKAGE_SUCCESS = '[ADMIN_EDM] Get dataset handoff package success';
export const GET_EDM_DATASET_HANDOFF_PACKAGE_FAILED = '[ADMIN_EDM] Get dataset handoff package failed';

export const GET_EDM_POLICY = '[ADMIN_EDM] Get policy';
export const GET_EDM_POLICY_SUCCESS = '[ADMIN_EDM] Get policy success';
export const GET_EDM_POLICY_FAILED = '[ADMIN_EDM] Get policy failed';

export const GET_EDM_ARTWORKS = '[ADMIN_EDM] Get artworks';
export const GET_EDM_ARTWORKS_SUCCESS = '[ADMIN_EDM] Get artworks success';
export const GET_EDM_ARTWORKS_FAILED = '[ADMIN_EDM] Get artworks failed';

export const GET_EDM_ARTWORK = '[ADMIN_EDM] Get artwork';
export const GET_EDM_ARTWORK_SUCCESS = '[ADMIN_EDM] Get artwork success';
export const GET_EDM_ARTWORK_FAILED = '[ADMIN_EDM] Get artwork failed';

export const UPDATE_EDM_ARTWORK_PROFILE = '[ADMIN_EDM] Update artwork profile';
export const UPDATE_EDM_ARTWORK_PROFILE_SUCCESS = '[ADMIN_EDM] Update artwork profile success';
export const UPDATE_EDM_ARTWORK_PROFILE_FAILED = '[ADMIN_EDM] Update artwork profile failed';

export const RECOMPUTE_EDM_ARTWORK = '[ADMIN_EDM] Recompute artwork';
export const RECOMPUTE_EDM_ARTWORK_SUCCESS = '[ADMIN_EDM] Recompute artwork success';
export const RECOMPUTE_EDM_ARTWORK_FAILED = '[ADMIN_EDM] Recompute artwork failed';

export const TRANSITION_EDM_ARTWORK = '[ADMIN_EDM] Transition artwork';
export const TRANSITION_EDM_ARTWORK_SUCCESS = '[ADMIN_EDM] Transition artwork success';
export const TRANSITION_EDM_ARTWORK_FAILED = '[ADMIN_EDM] Transition artwork failed';

export const VALIDATE_EDM_ARTWORK_MEDIA = '[ADMIN_EDM] Validate artwork media';
export const VALIDATE_EDM_ARTWORK_MEDIA_SUCCESS = '[ADMIN_EDM] Validate artwork media success';
export const VALIDATE_EDM_ARTWORK_MEDIA_FAILED = '[ADMIN_EDM] Validate artwork media failed';

export const GetEdmDatasets = (payload?: any) => ({ type: GET_EDM_DATASETS, payload });
export const GetEdmDatasetsSuccess = (payload: any) => ({ type: GET_EDM_DATASETS_SUCCESS, payload });
export const GetEdmDatasetsFailed = (payload: string) => ({ type: GET_EDM_DATASETS_FAILED, payload });

export const CreateEdmDataset = (payload: any) => ({ type: CREATE_EDM_DATASET, payload });
export const CreateEdmDatasetSuccess = (payload: any) => ({ type: CREATE_EDM_DATASET_SUCCESS, payload });
export const CreateEdmDatasetFailed = (payload: string) => ({ type: CREATE_EDM_DATASET_FAILED, payload });

export const GetEdmDataset = (payload: any) => ({ type: GET_EDM_DATASET, payload });
export const GetEdmDatasetSuccess = (payload: any) => ({ type: GET_EDM_DATASET_SUCCESS, payload });
export const GetEdmDatasetFailed = (payload: string) => ({ type: GET_EDM_DATASET_FAILED, payload });

export const UpdateEdmDataset = (payload: any) => ({ type: UPDATE_EDM_DATASET, payload });
export const UpdateEdmDatasetSuccess = (payload: any) => ({ type: UPDATE_EDM_DATASET_SUCCESS, payload });
export const UpdateEdmDatasetFailed = (payload: string) => ({ type: UPDATE_EDM_DATASET_FAILED, payload });

export const RecomputeEdmDataset = (payload: any) => ({ type: RECOMPUTE_EDM_DATASET, payload });
export const RecomputeEdmDatasetSuccess = (payload: any) => ({ type: RECOMPUTE_EDM_DATASET_SUCCESS, payload });
export const RecomputeEdmDatasetFailed = (payload: string) => ({ type: RECOMPUTE_EDM_DATASET_FAILED, payload });

export const GetEdmDatasetSummary = (payload: any) => ({ type: GET_EDM_DATASET_SUMMARY, payload });
export const GetEdmDatasetSummarySuccess = (payload: any) => ({ type: GET_EDM_DATASET_SUMMARY_SUCCESS, payload });
export const GetEdmDatasetSummaryFailed = (payload: string) => ({ type: GET_EDM_DATASET_SUMMARY_FAILED, payload });

export const GetEdmDatasetBlocked = (payload: any) => ({ type: GET_EDM_DATASET_BLOCKED, payload });
export const GetEdmDatasetBlockedSuccess = (payload: any) => ({ type: GET_EDM_DATASET_BLOCKED_SUCCESS, payload });
export const GetEdmDatasetBlockedFailed = (payload: string) => ({ type: GET_EDM_DATASET_BLOCKED_FAILED, payload });

export const ValidateEdmDatasetMedia = (payload: any) => ({ type: VALIDATE_EDM_DATASET_MEDIA, payload });
export const ValidateEdmDatasetMediaSuccess = (payload: any) => ({ type: VALIDATE_EDM_DATASET_MEDIA_SUCCESS, payload });
export const ValidateEdmDatasetMediaFailed = (payload: string) => ({ type: VALIDATE_EDM_DATASET_MEDIA_FAILED, payload });

export const GetEdmDatasetHandoffPackage = (payload: any) => ({ type: GET_EDM_DATASET_HANDOFF_PACKAGE, payload });
export const GetEdmDatasetHandoffPackageSuccess = (payload: any) => ({ type: GET_EDM_DATASET_HANDOFF_PACKAGE_SUCCESS, payload });
export const GetEdmDatasetHandoffPackageFailed = (payload: string) => ({ type: GET_EDM_DATASET_HANDOFF_PACKAGE_FAILED, payload });

export const GetEdmPolicy = (payload?: any) => ({ type: GET_EDM_POLICY, payload });
export const GetEdmPolicySuccess = (payload: any) => ({ type: GET_EDM_POLICY_SUCCESS, payload });
export const GetEdmPolicyFailed = (payload: string) => ({ type: GET_EDM_POLICY_FAILED, payload });

export const GetEdmArtworks = (payload?: any) => ({ type: GET_EDM_ARTWORKS, payload });
export const GetEdmArtworksSuccess = (payload: any) => ({ type: GET_EDM_ARTWORKS_SUCCESS, payload });
export const GetEdmArtworksFailed = (payload: string) => ({ type: GET_EDM_ARTWORKS_FAILED, payload });

export const GetEdmArtwork = (payload: any) => ({ type: GET_EDM_ARTWORK, payload });
export const GetEdmArtworkSuccess = (payload: any) => ({ type: GET_EDM_ARTWORK_SUCCESS, payload });
export const GetEdmArtworkFailed = (payload: string) => ({ type: GET_EDM_ARTWORK_FAILED, payload });

export const UpdateEdmArtworkProfile = (payload: any) => ({ type: UPDATE_EDM_ARTWORK_PROFILE, payload });
export const UpdateEdmArtworkProfileSuccess = (payload: any) => ({ type: UPDATE_EDM_ARTWORK_PROFILE_SUCCESS, payload });
export const UpdateEdmArtworkProfileFailed = (payload: { message: string; details?: unknown }) => ({ type: UPDATE_EDM_ARTWORK_PROFILE_FAILED, payload });

export const RecomputeEdmArtwork = (payload: any) => ({ type: RECOMPUTE_EDM_ARTWORK, payload });
export const RecomputeEdmArtworkSuccess = (payload: any) => ({ type: RECOMPUTE_EDM_ARTWORK_SUCCESS, payload });
export const RecomputeEdmArtworkFailed = (payload: string) => ({ type: RECOMPUTE_EDM_ARTWORK_FAILED, payload });

export const TransitionEdmArtwork = (payload: any) => ({ type: TRANSITION_EDM_ARTWORK, payload });
export const TransitionEdmArtworkSuccess = (payload: any) => ({ type: TRANSITION_EDM_ARTWORK_SUCCESS, payload });
export const TransitionEdmArtworkFailed = (payload: string) => ({ type: TRANSITION_EDM_ARTWORK_FAILED, payload });

export const ValidateEdmArtworkMedia = (payload: any) => ({ type: VALIDATE_EDM_ARTWORK_MEDIA, payload });
export const ValidateEdmArtworkMediaSuccess = (payload: any) => ({ type: VALIDATE_EDM_ARTWORK_MEDIA_SUCCESS, payload });
export const ValidateEdmArtworkMediaFailed = (payload: string) => ({ type: VALIDATE_EDM_ARTWORK_MEDIA_FAILED, payload });
